import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'SelectedScheduleTagSlider',
  inject: [
    '$utils'
  ],
  components: {
  },
  props: {
    tagsProp: {
      default () { return [] }
    },
    selectedUserDbIdProp: {
      default () { return null }
    }
  },
  watch: {
    tagsProp: {
      handler (newVal) {
        this.tags = this.filterTags(newVal)
        this.setDefaultData()
      },
      deep: true
    },
    selectedUserDbIdProp (newVal) {
      this.selectedUserDbId = newVal
      this.checkTagsVisibility()
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      tags: [],
      visibleTags: [],
      enableDeleteTags: true,
      selectedUserDbId: this.selectedUserDbIdProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('smart-text-tags-slider-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      this.tags = this.filterTags(this.tagsProp)
      this.visibleTags = this.tags
      this.checkTagsVisibility()

      this.$nextTick(_ => {
        /* $('.user-db-tags').each((i, el) => {
          let targetEl = $(el)
          if (!targetEl.hasClass('_toSeeAllData')) {
            targetEl.draggable({ helper: 'clone' })
          }
        }) */
      })
    },
    filterTags (tags) {
      let res = [
        {
          value: '_toSeeAllData',
          label: this.$t('label.all'),
          backgroundColor: '#fff'
        }
      ]

      res = res.concat(this.$utils.filterTagOptionsForUI({ tags, showLabel: true }))

      res = res.filter((tag) => { return !tag.value.includes(':') })

      return res
    },
    handleTagItemClick ($event, tag, indx) {
      this.emitEvent('TAGS_SELECTION', tag)
    },
    handleDeleteTag ($event, tag, indx) {
    },
    checkTagsVisibility () {
      if (this.selectedUserDbId) {
        this.visibleTags = this.tags.filter((tag) => { return tag.value === '_toSeeAllData' })
      } else {
        this.visibleTags = this.tags
      }
    },
    checkAllTagsLoaded () {
      if ($('.el-tag-user-db-tags').length >= this.tags.length) {
        this.$utils.updatePageComponentStyle({ name: 'userDbPageDefault' })
      }
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
